import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';
import '../sb-color/element.js';
import '../grid_list/element.js';

/**
 * Easy present multiple colors
 *
 * @prop grid - Add spacing between colors. Used for displaying multiple color that are not part of scale but belong in same context
 */
export default class SbColorPalette extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    title: { type: String },
    subtitle: { type: String },
    colors: { type: Array },
    grid: { type: Boolean },
  };

  /** @internal */
  get gap() {
    return this.grid ? 'large' : 'none';
  }

  renderColors() {
    return this.colors.map(color => html`<sb-color var=${color}></sb-color>`);
  }

  render() {
    return html`
      <header>
        <div class="title">${this.title}</div>
        <div class="subtitle">${this.subtitle}</div>
      </header>
      <ef-grid-list col="0" gap=${this.gap}>
        ${this.renderColors()}
      </ef-grid-list>
    `;
  }
}

customElements.get('sb-color-palette') ||
  customElements.define('sb-color-palette', SbColorPalette);
